export const principles = {
  title: "Nos Principes",
  subtitle: "Qu'est-ce qui nous rend différents ?",
  bookVisit: "Réservez une visite",
  items: {
    environment: {
      title: "Environnement préparé",
      description: "Espaces conçus pour promouvoir l'autonomie, la concentration et l'apprentissage actif"
    },
    respect: {
      title: "Respect mutuel",
      description: "Base de notre communauté éducative, favorisant des relations saines et la résolution pacifique des conflits"
    },
    learning: {
      title: "Apprentissage actif",
      description: "Les enfants construisent leurs connaissances à travers des expériences concrètes et significatives"
    },
    international: {
      title: "Perspective internationale",
      description: "Éducation trilingue (espagnol, anglais, Galician) et multiculturelle"
    },
    attention: {
      title: "Attention individualisée",
      description: "Ratio réduit qui nous permet de nous adapter au rythme et aux besoins de chaque élève"
    },
    development: {
      title: "Développement intégral",
      description: "Attention équilibrée aux capacités académiques, émotionnelles, sociales et physiques"
    }
  }
};
